/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { FormControlLabel, Typography } from "@mui/material";
import { useState } from "react";
import { TREE_OPERATIONS } from "../../../pages/CoverageRequirements/ItemDetails/constants";
import { getNodeById } from "../../../pages/CoverageRequirements/ItemDetails/Tabs/CoverageRequirementsTab/LeftPanelComponents/TreeComponent/CoverageRequirementsTreeComponent";
import ArgosButton, { ArgosLoadingButton } from "../../Buttons/ArgosButton";
import ArgosFlexbox from "../../Containers/ArgosFlexbox";
import ArgosCheckbox from "../../Form/Checkbox/ArgosCheckbox";


interface IDuplicateDialogProps {
    action: (action: TREE_OPERATIONS.DUPLICATE_DATASET, data: null) => void,
    onClose: () => void, 
    treeData: any,
    contextNodeId: string,
    data: any
}
const DuplicateDatasetDialog = (props: IDuplicateDialogProps) => {
    const [includeAnalysisResults, setincludeAnalysisResults] = useState<boolean>(false)
    const contextNodeId = props?.contextNodeId != undefined ? props?.contextNodeId : ""
    const treeData = props?.treeData != undefined ? props?.treeData : {}
    const datasetExecutionStatus: any = getNodeById(treeData, contextNodeId)?.executionStatus

    const handleDuplicate = () => {
        const operationData : any = props?.data
        operationData['includeAnalysisResults'] = includeAnalysisResults
        props.action(TREE_OPERATIONS.DUPLICATE_DATASET, operationData)
        props.onClose()
      }

    return(<>
        <ArgosFlexbox vertical>
            <Typography>
                This action creates an identical copy of the selected dataset. Do you wish to continue?
            </Typography>
            <FormControlLabel
                control={
                    <ArgosCheckbox
                        checked={includeAnalysisResults}
                        onChange={event => {}}
                        onClick={e => {setincludeAnalysisResults(!includeAnalysisResults)}}
                    />
                }
                disabled={datasetExecutionStatus != "Completed"}
                label={"Include Analysis Results in Copy"}
                key={1}
                onClick={e => e.preventDefault()}
           />
            <ArgosFlexbox style={{justifyContent: "center"}}>
                <ArgosButton onClick={() => props.onClose()}>
                    CANCEL
                </ArgosButton>
                <ArgosLoadingButton onClick={() => handleDuplicate()}>
                    CONFIRM
                </ArgosLoadingButton>
            </ArgosFlexbox>
        </ArgosFlexbox>
      </>)
}

export default DuplicateDatasetDialog;